import Bugsnag from "@bugsnag/js"

// Bugsnag only starts when window.bugsnagSettings is present (production, or
// staging with BUGSNAG_JS_API_KEY and BUGSNAG_RELEASE_STAGE set — see
// app/views/shared/_bugsnag_js.slim). Guarding here keeps notify a no-op
// everywhere else instead of emitting "notify() called before start()"
// warnings in dev and tests.
//
// `sections` maps a Bugsnag tab name to a values object, e.g.
//   notifyBugsnag(error, { thoughtspot: { liveboardId, scope } })
//
// `unhandled: true` files the event like a crash the React plugin caught
// (unhandled, severity error) rather than as a handled warning.
export const notifyBugsnag = (
  error,
  sections = {},
  { unhandled = false } = {}
) => {
  if (!window.bugsnagSettings) return

  Bugsnag.notify(error, (event) => {
    if (unhandled) {
      event.unhandled = true
      event.severity = "error"
    }
    Object.entries(sections).forEach(([section, values]) => {
      event.addMetadata(section, values)
    })
  })
}
